export default {
  dailyCheck: {
    itself: 'Daily Check',
    plural: {
      itself: 'Daily Checks',
    },
  },
};
